import { Typography } from "@mui/material";
import React from "react";
import { TitumDetails } from "./TitumDetails";

function Footer() {
  return (
    <Typography
      variant="body2"
      style={{ margin: 10 }}
      color="textSecondary"
      align="center"
    >
      `{TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}
      `
      <br />
      {"Copyright © "}
      Titum {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Footer;
